import { ReportsProvider } from "../../providers/reports/reports";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { MediaProvider } from "../../providers/media/media";
import { ListasProvider } from "../../providers/listas/listas";
import { DuvidasSugestoesModel } from "./duvidas-sugestoes.modelview";
import { UserProvider } from "../../providers/user/user";

@Injectable()
export class DuvidasSugestoesPageProvider {
    constructor(
        public reportProvider: ReportsProvider,
        public mediaProvider: MediaProvider,
        public listsProvider: ListasProvider,
        public userProvider: UserProvider,
    ) { }

    requestLists(): Observable<any> {
        return this.listsProvider.requestAllLists()
    }

    sendImage(imageData: any): Observable<any> {
        return Observable.create(observer => {
            this.mediaProvider.sendMediaByFile(imageData).subscribe(data => {
                observer.next(data)
                console.log("requestFile sucess", data)
            }, err => {
                observer.error(err.message)
                console.log("requestFile error", err)
            })
        })
    }

    sendImageFile(file: File): Observable<any> {
        return Observable.create(observer => {
            this.mediaProvider.sendMediaByFileObj(file).subscribe(data => {
                observer.next(data)
                console.log("requestFile sucess", data)
            }, err => {
                observer.error(err.message)
                console.log("requestFile error", err)
            })
        })
    }

    requestSupport(model: DuvidasSugestoesModel): Observable<any> {
        return Observable.create(subscribe => {
            this.reportProvider.enviarDuvidasESugestoes(model.assunto, model.mensagem, model.anexo).subscribe(data => {
                subscribe.next(data)
            }, error => {
                subscribe.error(error)
            })
        })
    }

    getUserData(): Observable<any> {
        return Observable.create(subscribe => {
            subscribe.next(this.userProvider.getUserStoraged())
        })
    }
}


// WEBPACK FOOTER //
// ./src/pages/duvidas-sugestoes/duvidas-sugestoes.provider.ts